import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  changeFormulaType,
  changeFormulaTypeFromDays,
} from "../../actions/formulaAction";

const RawToGranularPopup = ({
  closePopup,
  isRawType,
  setPrepMethod,
  setDays,
  setRawGram,
  preparationMethods,
  setTimePerDay,
  setMultiplier,
  setIsConverted = null,
}) => {
  const dispatch = useDispatch();
  const [innerDays, setInnerDays] = useState(1);

  return (
    <Modal show={true} id="prescription-popup">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">
                    Please enter the total days you would like to prescribe in
                    order to convert to granular
                  </h2>
                  <p className="desc">
                    You can change this amount anytime on the prescription page.
                  </p>
                </div>
                <div className="col-md-12">
                  <input
                    className="gram-input"
                    type="number"
                    step="any"
                    value={innerDays}
                    onChange={(e) => {
                      setInnerDays(parseInt(e.target.value));
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end">
            <button
              className="btn-orange"
              disabled={innerDays <= 0}
              onClick={() => {
                dispatch(changeFormulaTypeFromDays(!isRawType, innerDays));
                setRawGram();
                setPrepMethod &&
                  setPrepMethod(preparationMethods?.find((x) => x.id == 1));
                setDays && setDays(innerDays);
                setMultiplier && setMultiplier(innerDays);
                setTimePerDay && setTimePerDay(2);
                setIsConverted && setIsConverted(true);
                closePopup();
              }}
            >
              Convert
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default RawToGranularPopup;
